<template>
  <div ref="modalRef" class="modal full active" v-if="show">
    <slot></slot>
    <div class="bg" @click="closeModal"></div>
  </div>
</template>

<script>
import toggleMixin from "@/mixins/toggleMixin";
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock-upgrade'

export default {
  name: 'TheModal',
  mixins: [toggleMixin],
  props: {
    title: {
      type: String,
      default: null,
    },
    canClose: {
      type: Boolean,
      default: true,
    },
    scrollTargetClass: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      scrollTargetEl: null,
    }
  },

  watch: {
    show(value) {
      if (value) {
        this.$nextTick(() => {
          if (!this.$refs.modalRef) {
            return
          }

          // Если передан класс — ищем внутренний скроллируемый контейнер,
          // иначе по‑прежнему блокируем саму модалку (обратная совместимость).
          const target =
            this.scrollTargetClass
              ? this.$refs.modalRef.querySelector(`.${this.scrollTargetClass}`)
              : this.$refs.modalRef

          if (target) {
            this.scrollTargetEl = target
            disableBodyScroll(this.scrollTargetEl)
          }
        })
      } else if (this.scrollTargetEl) {
        enableBodyScroll(this.scrollTargetEl)
        this.scrollTargetEl = null
      }
    }
  },

  unmounted() {
    clearAllBodyScrollLocks()
  },
  // watch:{
  //   show(value){
  //     if(value){
  //       if(typeof window !== 'undefined'){
  //         window.scroll({
  //           top: 0,
  //           behavior: 'smooth'
  //         })
  //       }
  //
  //     }
  //   }
  // },
  methods: {
    closeModal() {
      if (this.canClose) {
        this.hideDialog()
      }
    }
  }
};
</script>
